import React, { useState, useEffect } from 'react';
import api from '../api';
import { FaEdit, FaTrash, FaPlus, FaTimes, FaFileExcel } from 'react-icons/fa';
import EmbalagemImport from './EmbalagemImport';


const Embalagens = () => {
    const [embalagens, setEmbalagens] = useState([]);
    const [mostrarModal, setMostrarModal] = useState(false);
    const [embalagemEditando, setEmbalagemEditando] = useState(null);
    const [busca, setBusca] = useState('');
    const [loading, setLoading] = useState(false);
    const [mostrarModalImportacao, setMostrarModalImportacao] = useState(false);


    useEffect(() => {
        carregarEmbalagens();
    }, []);

    const carregarEmbalagens = async () => {
        try {
            setLoading(true);
            const response = await api.get('/api/embalagens'); // ✅ CORRIGIDO
            setEmbalagens(response.data);
        } catch (error) {
            console.error('Erro ao carregar embalagens:', error);
            alert('Erro ao carregar embalagens');
        } finally {
            setLoading(false);
        }
    };

    const abrirModal = (embalagem = null) => {
        setEmbalagemEditando(embalagem);
        setMostrarModal(true);
    };

    const fecharModal = () => {
        setEmbalagemEditando(null);
        setMostrarModal(false);
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Deseja realmente excluir esta embalagem?')) return;

        try {
            await api.delete(`/api/embalagens/${id}`); // ✅ CORRIGIDO
            alert('Embalagem excluída com sucesso!');
            carregarEmbalagens();
        } catch (error) {
            console.error('Erro ao excluir embalagem:', error);
            alert('Erro ao excluir embalagem');
        }
    };

    const embalagensFiltradas = embalagens.filter(e =>
        e.nome.toLowerCase().includes(busca.toLowerCase())
    );

    const formatarMoeda = (valor) => {
        return `R$ ${parseFloat(valor || 0).toFixed(2).replace('.', ',')}`;
    };

    return (
        <div className="container mx-auto p-4 md:p-6">
            <div className="bg-white rounded-lg shadow-lg p-6">
               <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6 gap-4">
                    <h1 className="text-2xl md:text-3xl font-bold text-gray-800">
                        📦 Embalagens
                    </h1>
                    <div className="flex gap-2">
                        <button
                            onClick={() => setMostrarModalImportacao(true)}
                            className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition flex items-center justify-center gap-2"
                        >
                            <FaFileExcel /> Importar Excel
                        </button>
                        <button
                            onClick={() => abrirModal()}
                            className="bg-green-500 text-white px-4 py-2 rounded-lg hover:bg-green-600 transition flex items-center justify-center gap-2"
                        >
                            <FaPlus /> Nova Embalagem
                        </button>
                    </div>
                </div>

                {/* Busca */}
                <div className="mb-4">
                    <input
                        type="text"
                        placeholder="Buscar embalagem..."
                        value={busca}
                        onChange={(e) => setBusca(e.target.value)}
                        className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                </div>

                {/* Tabela */}
                {loading ? (
                    <div className="text-center py-8">
                        <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
                        <p className="mt-2 text-gray-600">Carregando...</p>
                    </div>
                ) : embalagensFiltradas.length === 0 ? (
                    <div className="text-center py-8 text-gray-500">
                        {busca ? 'Nenhuma embalagem encontrada' : 'Nenhuma embalagem cadastrada'}
                    </div>
                ) : (
                    <div className="overflow-x-auto">
                        <table className="w-full">
                            <thead className="bg-gray-100">
                                <tr>
                                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">
                                        Nome
                                    </th>
                                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">
                                        Custo Unitário
                                    </th>
                                    <th className="px-4 py-3 text-center text-sm font-semibold text-gray-700">
                                        Ações
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200">
                                {embalagensFiltradas.map((embalagem) => (
                                    <tr key={embalagem.id} className="hover:bg-gray-50">
                                        <td className="px-4 py-3 text-sm text-gray-900">
                                            {embalagem.nome}
                                        </td>
                                        <td className="px-4 py-3 text-sm text-gray-900">
                                            {formatarMoeda(embalagem.custo_unitario)}
                                        </td>
                                        <td className="px-4 py-3 text-center">
                                            <div className="flex items-center justify-center gap-2">
                                                <button
                                                    onClick={() => abrirModal(embalagem)}
                                                    className="text-blue-600 hover:text-blue-800 transition"
                                                    title="Editar"
                                                >
                                                    <FaEdit size={18} />
                                                </button>
                                                <button
                                                    onClick={() => handleDelete(embalagem.id)}
                                                    className="text-red-600 hover:text-red-800 transition"
                                                    title="Excluir"
                                                >
                                                    <FaTrash size={18} />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}

                {/* Total */}
                {embalagensFiltradas.length > 0 && (
                    <div className="mt-4 text-sm text-gray-600">
                        Total: {embalagensFiltradas.length} embalagem(ns)
                    </div>
                )}
            </div>

            {/* Modal de Cadastro/Edição */}
            {mostrarModal && (
                <EmbalagemModal
                    embalagem={embalagemEditando}
                    fecharModal={fecharModal}
                    recarregar={carregarEmbalagens}
                />
            )}

            {/* Modal de Importação */}
            {mostrarModalImportacao && (
                <EmbalagemImport
                    fecharModal={() => setMostrarModalImportacao(false)}
                    recarregar={carregarEmbalagens}
                />
            )}
        </div>
    );
};

// Modal de Cadastro/Edição
const EmbalagemModal = ({ embalagem, fecharModal, recarregar }) => {
    const [nome, setNome] = useState(embalagem?.nome || '');
    const [custoFormatado, setCustoFormatado] = useState('');
    const [custoUnitario, setCustoUnitario] = useState(embalagem?.custo_unitario || 0);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (embalagem?.custo_unitario) {
            const valorFormatado = parseFloat(embalagem.custo_unitario)
                .toFixed(2)
                .replace('.', ',');
            setCustoFormatado(valorFormatado);
        }
    }, [embalagem]);

    const handleCustoChange = (e) => {
        const raw = e.target.value.replace(/\D/g, '');
        const centavos = raw.padStart(3, '0');
        const reais = centavos.slice(0, -2);
        const cent = centavos.slice(-2);
        const formatado = `${Number(reais).toLocaleString('pt-BR')},${cent}`;
        setCustoFormatado(formatado);
        const valorFinal = parseFloat(`${reais}.${cent}`);
        setCustoUnitario(valorFinal);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!nome.trim()) {
            setError('Nome é obrigatório');
            return;
        }

        if (!custoUnitario || custoUnitario <= 0) {
            setError('Custo unitário deve ser maior que zero');
            return;
        }

        try {
            setLoading(true);
            const data = {
                nome: nome.trim(),
                custo_unitario: custoUnitario
            };

            if (embalagem) {
                await api.put(`/api/embalagens/${embalagem.id}`, data); // ✅ CORRIGIDO
                alert('Embalagem atualizada com sucesso!');
            } else {
                await api.post('/api/embalagens', data); // ✅ CORRIGIDO
                alert('Embalagem cadastrada com sucesso!');
            }

            recarregar();
            fecharModal();
        } catch (error) {
            console.error('Erro ao salvar embalagem:', error);
            setError('Erro ao salvar embalagem');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div 
            className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 p-4"
            style={{ zIndex: 9999 }}
        >
            <div 
                className="bg-white rounded-lg shadow-lg w-full max-w-md relative"
                style={{ maxHeight: '90vh', overflowY: 'auto' }}
            >
                <div className="sticky top-0 bg-white border-b px-6 py-4 flex items-center justify-between">
                    <h2 className="text-xl font-semibold text-gray-700">
                        {embalagem ? 'Editar Embalagem' : 'Nova Embalagem'}
                    </h2>
                    <button
                        onClick={fecharModal}
                        className="text-gray-400 hover:text-gray-600 transition"
                    >
                        <FaTimes size={20} />
                    </button>
                </div>

                <div className="p-6">
                    {error && (
                        <div className="mb-4 p-3 bg-red-100 text-red-700 border border-red-400 rounded text-sm">
                            {error}
                        </div>
                    )}

                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Nome da Embalagem *
                            </label>
                            <input
                                type="text"
                                value={nome}
                                onChange={(e) => setNome(e.target.value)}
                                placeholder="Ex: Caixa 15x15, Saco Plástico..."
                                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                required
                                autoFocus
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Custo Unitário (R$) *
                            </label>
                            <input
                                type="text"
                                value={custoFormatado}
                                onChange={handleCustoChange}
                                placeholder="0,00"
                                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                required
                            />
                        </div>

                        <div className="flex gap-3 pt-4">
                            <button
                                type="submit"
                                disabled={loading}
                                className="flex-1 bg-green-500 text-white py-2 px-4 rounded-lg hover:bg-green-600 transition disabled:bg-gray-400"
                            >
                                {loading ? 'Salvando...' : (embalagem ? 'Atualizar' : 'Cadastrar')}
                            </button>
                            <button
                                type="button"
                                onClick={fecharModal}
                                disabled={loading}
                                className="flex-1 bg-gray-500 text-white py-2 px-4 rounded-lg hover:bg-gray-600 transition disabled:bg-gray-400"
                            >
                                Cancelar
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Embalagens;